var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWireCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26.2727,
    height: 19,
    rx: 1.5,
    stroke: "#555555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0947,
    y: 5.71045,
    width: 4.09091,
    height: 1.07143,
    rx: 0.535714,
    fill: "#555555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0918,
    y: 9.28955,
    width: 19.0909,
    height: 1.07143,
    rx: 0.535714,
    fill: "#555555"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0918,
    y: 12.145,
    width: 19.0909,
    height: 1.07143,
    rx: 0.535714,
    fill: "#555555"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.999,
    y: 15.7139,
    width: 8.18182,
    height: 1.07143,
    rx: 0.535714,
    fill: "#555555"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0918,
    y: 3.56885,
    width: 4.77273,
    height: 2.85714,
    rx: 0.5,
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWireCard);
export default __webpack_public_path__ + "static/media/check-wire-card.f47e184fc9035d7e7e4cd0d127e37d2b.svg";
export { ForwardRef as ReactComponent };